module.exports = __webpack_public_path__ + "images/help_v2/avatars/maklu-5b9bf1b1601b0d7ce5fd40908442dfbc.png";